module.exports = "<div class=\"code-block\">\n  <div>\n    <pre><code ng-bind-html=\"vm.sourceHtml\"></code></pre>\n  </div>\n</div>\n"